import { render } from "./MessageBox.vue?vue&type=template&id=7d65d108&scoped=true&ts=true"
import script from "./MessageBox.vue?vue&type=script&lang=ts"
export * from "./MessageBox.vue?vue&type=script&lang=ts"

import "./MessageBox.vue?vue&type=style&index=0&id=7d65d108&scoped=true&lang=scss"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d65d108"]])

export default __exports__